"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getProp = _interopRequireDefault(require("../utils/getProp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var color = function color(c) {
  return (0, _getProp["default"])("color", c);
};

color.white = function () {
  return color("white");
};

color.bg = function () {
  return color("bg");
};

color.subtleHover = function () {
  return color("subtleHover");
};

color.bgGray = function () {
  return color("bgGray");
};

color.line = function () {
  return color("line");
};

color.gray = function () {
  return color("gray");
};

color.wcag = function () {
  return color("wcag");
};

color.disabled = function () {
  return color("disabled");
};

color.primary = function () {
  return color("primary");
};

color.secondary = function () {
  return color("secondary");
};

color.text = function () {
  return color("text");
};

color.negative = function () {
  return color("negative");
};

color.positive = function () {
  return color("positive");
};

color.warning = function () {
  return color("warning");
};

color.black = function () {
  return color("black");
};

color.green = function () {
  return color("green");
};

color.link = function () {
  return color("link");
};

var _default = color;
exports["default"] = _default;